<script setup>
import { onUpdated, onMounted, onUnmounted } from "vue";
import { useRoute } from "vue-router";
const route = useRoute();

import TheHeader from "@/components/TheHeader.vue";
import TheFooter from "@/components/TheFooter.vue";
import AlertMessage from "@/components/AlertMessage.vue";

import { useAuthStore } from "@/stores/auth";
const authStore = useAuthStore();

import { useAlertStore } from "@/stores/alert";
const alertStore = useAlertStore();

import subscriptionService from "@/lib/subscriptionService";

function oAuthCallbackCheck() {
  if (route.fullPath == "/?auth") authStore.oAuthCallback();
}

onMounted(() => {
  // Initialize subscription polling if user is already logged in and on a paid plan
  // Only poll for 'pro' subscriptions, regardless of autoRenew status
  if (authStore.status.loggedIn && authStore.user?.subscription?.type === 'pro') {
    subscriptionService.startPolling(authStore);
  }

  // Stop polling when page is about to be unloaded
  const handleBeforeUnload = () => {
    subscriptionService.stopPolling();
  };
  
  window.addEventListener('beforeunload', handleBeforeUnload);
  
  // Cleanup event listener on unmount
  onUnmounted(() => {
    window.removeEventListener('beforeunload', handleBeforeUnload);
  });
});

onUnmounted(() => {
  // Stop polling when component is unmounted (page closed/refreshed)
  subscriptionService.stopPolling();
});

onUpdated(() => {
  alertStore.reset();
  if (route.fullPath == "/?auth") authStore.oAuthCallback();
});
</script>

<template>
  <div class="app-container">
    <div class="container-fluid">
      <div
        v-if="$env.VUE_APP_MAINTENANCE_MODE === 'true'"
        class="alert-warning alert fade show text-center mt-3"
      >
        {{ $t("common.maintenanceMode") }}
      </div>
      <div v-else-if="route.path == '/login'">
        <AlertMessage />
        <router-view />
      </div>
      <div v-else>
        <TheHeader v-if="route.path != '/login'" />
        <div class="__clear-header">
          <AlertMessage />
          <router-view />
        </div>
      </div>
    </div>
    <TheFooter v-if="route.path != '/login'" />
  </div>
</template>

<style>
@import "@/assets/css/main.css";
</style>
